/**
 * isDefinedAndNotEmpty - checks to make sure a string is defined and not empty
 * @param value
 */
export function isDefinedAndNotEmpty(value: string | undefined | null): boolean {
  return value !== undefined && value != null && value.trim() !== "";
}
